import React, { useEffect, useRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import app from 'srcJs/App';
import { useUserData } from 'components/user/hooks/use-user-data';
import { PopoverStickOnHover } from 'components/popover/PopoverStickOnHover';
import classNames from 'classnames';
import { When } from 'react-if';
import { Variant } from '@collaborator/npm_modules/dist/css/variant';
import { Badge } from 'ui/badge/Badge';

var DropdownToggle = function DropdownToggle(_ref) {
  var isOpen = _ref.isOpen;
  var userData = useUserData();
  var refPopover = useRef();
  useEffect(function () {
    var _refPopover$current;

    // @ts-ignore
    (_refPopover$current = refPopover.current) === null || _refPopover$current === void 0 ? void 0 : _refPopover$current.hide();
  }, [isOpen]);

  var renderBalance = function renderBalance() {
    if (!userData.balanceData.hasCreditLimit) {
      return /*#__PURE__*/React.createElement("span", {
        className: "font-weight-bold"
      }, userData.balanceData.valueFormat);
    }

    return /*#__PURE__*/React.createElement(PopoverStickOnHover, {
      text: userData.balanceData.tooltip,
      asHtml: true,
      placement: "bottom",
      popoverProps: {
        bsPrefix: 'popover popover_full-width'
      },
      ref: refPopover
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames('font-weight-bold', {
        'text-danger': userData.balanceData.isNegative
      })
    }, userData.balanceData.valueFormat));
  };

  return /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    variant: "link",
    id: "dropdown-balance-button",
    className: "d-flex text-reset text-h-primary text-decoration-none px-0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "fs-12 color-858585 mr-8p"
  }, app.tForReact('base', 'Balance')), renderBalance(), /*#__PURE__*/React.createElement(When, {
    condition: userData.invoiceNotify
  }, /*#__PURE__*/React.createElement(Badge, {
    variant: Variant.warning,
    pill: true,
    additionalClassName: "text-white ml-1"
  }, userData.invoiceNotify)));
};

export { DropdownToggle };